import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const createPickSessionPriorityFilter = {
  name: "createPickSessionPriorityFilter" as const,
  input: z.object({
    name: z.string(),
    filters: z.array(AdvancedFilterDataSchema),
    filterGroup: FilterGroupSchema.optional(),
    percentage: z.number().min(0).max(100),
  }),
  output: z.object({ success: z.boolean() }),
};
